import { get } from "lodash";

import { FilterFieldOptionsHookResult } from "~/features/filter";
import { useGetLocationData } from "~/hooks/locationData";
import { language } from "~/libs/getData";
import {
  DealersLocationItem,
  useGetDealersLocationItemQuery,
} from "~/schemas/generated/graphql";

/**
 * Опции локаций дилеров (страна/ФО/регион/город). Как в старом фильтре,
 * список сужается остальными выбранными локациями — значения берём из URL
 * (применённые фильтры), само поле в переменные запроса не передаём.
 */
const useLocationItemOptions = (
  item: DealersLocationItem,
): FilterFieldOptionsHookResult => {
  const isEn = language === "en";
  const { FO, subject, country, city } = useGetLocationData() as Record<
    string,
    unknown
  >;

  const locationValue = (value: unknown) => (value ? String(value) : undefined);

  const { data, loading } = useGetDealersLocationItemQuery({
    variables: {
      item,
      FO: item !== DealersLocationItem.Fo ? locationValue(FO) : undefined,
      subject:
        item !== DealersLocationItem.Subject
          ? locationValue(subject)
          : undefined,
      country:
        item !== DealersLocationItem.Country
          ? locationValue(country)
          : undefined,
      city: item !== DealersLocationItem.City ? locationValue(city) : undefined,
    },
  });

  const items: string[] = get(
    data,
    `DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`,
    [],
  );

  return {
    options: items.map((value) => ({ value, label: value })),
    loading,
  };
};

export const useCountryOptions = (): FilterFieldOptionsHookResult =>
  useLocationItemOptions(DealersLocationItem.Country);

export const useFederalAreaOptions = (): FilterFieldOptionsHookResult =>
  useLocationItemOptions(DealersLocationItem.Fo);

export const useSubjectOptions = (): FilterFieldOptionsHookResult =>
  useLocationItemOptions(DealersLocationItem.Subject);

export const useCityOptions = (): FilterFieldOptionsHookResult =>
  useLocationItemOptions(DealersLocationItem.City);
